import {stripBackgroundAndCSSImages} from '../../../../../../../libs/shared/core/src/helpers/browser/domHelpers';
import {sanitizeHtml} from '../../../../../../../libs/shared/core/src/helpers/sanitization/html';
import {CleanHtml} from '../../../../../../../libs/shared/core/src/helpers/typescript/cleanHtml';
import {replaceImageNodesWithPlaceholder} from '../../../../../../helpers/domPurifyHelpers';

export function stripExternalContentFromBody(body: CleanHtml): CleanHtml {
  const uponSanitizeElement = (element: Element) => {
    replaceImageNodesWithPlaceholder(element);
    stripBackgroundAndCSSImages(element);
  };

  return sanitizeHtml(body, {
    hooks: {uponSanitizeElement},
  });
}
